import { useContext } from "react";
import { OidcConfigListContext } from "../contexts/OidcConfigListContext";

export const useOidcConfigList = () => {
  const context = useContext(OidcConfigListContext);
  if (context === undefined) {
    throw new Error(
      "useOidcConfigList must be used within an OidcConfigListProvider",
    );
  }
  return context;
};
